export default __webpack_public_path__ + "static/media/apple-juice-menu.0114255e.png";